import * as React from 'react';
import { IconAndText } from '@blueprint/ui';
import { Icons } from '@blueprint/ui/dist/Icon/icons';
import {
    SavedListingPrice,
    SavedListingTransports,
    SavedListingLink,
    SavedListingTransportList
} from './ListingCardLandscape.styles';
import { Transport } from '../../graphql.generated';

export const NearestTransport = ({
    transport
}: {
    transport: Transport | null;
}) => {
    return transport ? (
        <SavedListingTransportList>
            <SavedListingTransports
                key={`${transport.poiType}-${transport.title}`}
            >
                <IconAndText
                    isInline
                    iconId={transport.poiType as Icons}
                    content={`${transport.distanceInMiles} miles from ${transport.title}`}
                    contentColor="grey-steel"
                    iconColor="grey-steel"
                    size="small"
                />
            </SavedListingTransports>
        </SavedListingTransportList>
    ) : null;
};

export const ListingCardLandscapeDetail = ({
    listingLinkHref,
    onClick,
    children
}: {
    listingLinkHref?: string;
    onClick?: () => void;
    children: React.ReactNode;
}) => {
    return listingLinkHref ? (
        <SavedListingLink href={listingLinkHref} onClick={onClick}>
            {children}
        </SavedListingLink>
    ) : (
        <div>{children}</div>
    );
};

export const ListingCardLandscapePrice = ({
    price
}: {
    price: string | null | undefined;
}) => {
    return price ? <SavedListingPrice>{price}</SavedListingPrice> : null;
};
